var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4DigitalTimeSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 51h-4v4h4v-4zM50 21H26v16h24V21zM40 51h-4v4h4v-4zM30 51h-4v4h4v-4z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12V9H25v3h-8v52h8v3h26v-3h8V12h-8zm-30 4h34v26H21V16zm34 44H21V46h34v14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Digital_time_switch.c061bcad.svg";
export { SvgA4DigitalTimeSwitch as ReactComponent };